/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { datasets_datasources_harvestResponse } from '../types/datasets_datasources_harvest';

export type DatasetsDatasourcesHarvestPartialUpdateRequest = {} | null | undefined;
export type DatasetsDatasourcesHarvestPartialUpdateResponse = datasets_datasources_harvestResponse;

export type DatasetsDatasourcesHarvestPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this dataset datasource.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/datasets_datasources/{id}/harvest/
 *
 * ```yaml
 * operationId: datasets_datasources_harvest_partial_update
 * description: |-
 *   metoda patch, bez parametru
 *   vrati {"state": "WAITING_FOR_PROCESSING"}
 * tags:
 *   - datasets_datasources
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/datasets_datasources_harvest'
 *     description: 'Harvest zařazen do fronty (state: WAITING_FOR_PROCESSING).'
 *   '409':
 *     content:
 *       application/json:
 *         schema:
 *           type: object
 *           properties:
 *             message:
 *               type: string
 *             code:
 *               type: string
 *             state:
 *               type: string
 *               enum:
 *                 - WAITING_FOR_PROCESSING
 *                 - PROCESSING
 *           required:
 *             - message
 *             - code
 *             - state
 *     description: >-
 *       Harvest zdroje už čeká na zpracování nebo běží (code:
 *       vydej_harvest_already_running).
 * ```
 */
export const datasetsDatasourcesHarvestPartialUpdateOperation = ({
  id,
  ...rest
}: DatasetsDatasourcesHarvestPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/datasets_datasources/${id}/harvest/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/datasets_datasources/{id}/harvest/' };
  };

/**
 * PATCH /dmx-server/datasets_datasources/{id}/harvest/
 *
 * ```yaml
 * operationId: datasets_datasources_harvest_partial_update
 * description: |-
 *   metoda patch, bez parametru
 *   vrati {"state": "WAITING_FOR_PROCESSING"}
 * tags:
 *   - datasets_datasources
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/datasets_datasources_harvest'
 *     description: 'Harvest zařazen do fronty (state: WAITING_FOR_PROCESSING).'
 *   '409':
 *     content:
 *       application/json:
 *         schema:
 *           type: object
 *           properties:
 *             message:
 *               type: string
 *             code:
 *               type: string
 *             state:
 *               type: string
 *               enum:
 *                 - WAITING_FOR_PROCESSING
 *                 - PROCESSING
 *           required:
 *             - message
 *             - code
 *             - state
 *     description: >-
 *       Harvest zdroje už čeká na zpracování nebo běží (code:
 *       vydej_harvest_already_running).
 * ```
 */
export const datasetsDatasourcesHarvestPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DatasetsDatasourcesHarvestPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<datasets_datasources_harvestResponse>> => {
  const operation = datasetsDatasourcesHarvestPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
